import { render } from "./plug.vue?vue&type=template&id=48dc5ae5"
import script from "./plug.vue?vue&type=script&lang=js"
export * from "./plug.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__